export const GAME_ID = "Spinball2024";
export const API_URL = process.env.REACT_APP_API_URL || "";
export const GLOBAL_API = process.env.REACT_APP_GLOBAL_API || "";
export const BASE_DOMAIN = process.env.REACT_APP_BASE_DOMAIN || "";
export const JSON_URL = process.env.REACT_APP_JSON_URL || "";
export const CONTENT_JSON_URL = process.env.REACT_APP_CONTENT_JSON_URL || "";
export const BASE_URL = process.env.REACT_APP_BASE_URL || "/";
export const STORAGE_VERSION = process.env.REACT_APP_STORAGE_VERSION || "/";
export const SENTRY_DSN_URL = process.env.REACT_APP_SENTRY_DSN_URL;
export const SHARE_URL = process.env.REACT_APP_SHARE_URL || "";
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL || "";
export const SSO_PREFIX = process.env.REACT_APP_SSO_PREFIX || "";
export const PUB_NUB_ENV = process.env.REACT_APP_PUB_NUB_ENV || "";

export const EMAIL_REGEXP = "\\S+@\\S+\\.\\S+";
export const PASSWORD_PATTERN =
	"^((?=.*?\\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[\\-!@#$%^&*\\(\\)_+\\|~=`\\{\\}\\[\\]:\";'<>?,.\\/])).{8,}$";

export const PASSWORD_REQUIREMENTS =
	"Password must include 8 characters, including 1 upper case character, 1 number and 1 special character";

export const FACEBOOK_ID = process.env.REACT_APP_FACEBOOK_APP_ID || false;

export const MLB_PLAYER_AVATAR_IMAGES = process.env.REACT_APP_MLB_PLAYER_AVATAR_IMAGES || "";
export const MLB_PLAYER_SHOT_IMAGES = process.env.REACT_APP_MLB_PLAYER_SHOT_IMAGES || "";
export const MLB_PLAYER_FULL_IMAGES = process.env.REACT_APP_MLB_PLAYER_FULL_IMAGES || "";

export const IS_SSO_BACKDOOR =
	window.location.href.includes("backdoor") ||
	process.env.REACT_APP_IS_BACKDOOR === "true" ||
	sessionStorage.getItem("backdoor") === "true";
export const IS_PROD = process.env.REACT_APP_ENVIRONMENT === "production";

export const GAME_TIMEZONE = "America/New_York";
